import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'
import errors from './Errors'

Vue.use(Vuex)

/*
function normalizeEntityName( id, entity, fallback ) {
    let name = '-';
    if(id && id != '') {
        name = '' +id;
    }
    if(entity) {
        name = entity.name;
        name = (name !== undefined && name != '') ? name : fallback;
    }
    return name ?? '-';
}

function wait(ms, value) {
    return new Promise(resolve => setTimeout(resolve, ms, value));
}

 */

/*
var defaultEntityProvider = {

    getEmptyName() { return '(empty name)' },
    getById( id ) { return null },
    augmentEntity( base, entity ) { return entity }
    getEntityId(entity) { return entity.id }
}

 */

const REQUEST_DELAY = 100;

export default class {
    constructor ( entityProvider ) {

        let self = this;

        this.state = {
            currentId: null,
            current: null,
            currentLoading: false,
            currentLoadingError: false,
            currentLoadingErrorValue: null,
            currentDirty: true,

            items: { data:[], total: 0 },
            itemsLoading: false,
            itemsLoadingError: false,
            itemsLoadingErrorValue: null,
            itemsDirty: true,

            itemsNavigation: {
                current: 0,
                total: 0,
                nextId: 0,
                previousId: 0,
                hasNext: false,
                hasPrevious: false,
                hasCurrent: false,
            }
        };

        this.getters = {

            currentId:(state) => state.currentId,

            current:(state) => state.current,
            currentDirty:(state) => state.currentDirty,
            currentLoading:(state) => state.currentLoading,
            currentLoadingError: (state) => state.currentLoadingError,
            currentLoadingErrorValue: (state) => state.currentLoadingErrorValue,
            currentLoadingOrNull:(state) => state.currentLoading || (!state.current),

            currentName:(state) => {
                return self.normalizeEntityName(state.currentId, state.current, entityProvider.getEmptyName())
            },

            items:(state) => state.items,
            itemsLoading:(state) => state.itemsLoading,
            itemsLoadingError:(state) => state.itemsLoadingError,
            itemsLoadingErrorValue:(state) => state.itemsLoadingErrorValue,
            itemsDirty:(state) => state.itemsDirty,

            itemsNavigation:(state) => state.itemsNavigation,
        };

        this.mutations = {
            setCurrent (state, { id, model }) {
                state.currentId = id;
                state.current = entityProvider.augmentEntity(self, model);

                let itemsNav = state.itemsNavigation;

                if(!state.current || !state.items || state.items.data.length < 1) {
                    itemsNav.current = !state.current ? 0 : 1;
                    itemsNav.total = !state.current ? 0 : 1;
                    itemsNav.nextId = -1;
                    itemsNav.previousId = -1;
                    itemsNav.hasNext = false;
                    itemsNav.hasPrevious = false;
                    itemsNav.hasCurrent = !!state.current;
                } else if(state.current && state.items) {
                    let index = state.current.index ?? -1;
                    let items = state.items.data;
                    if(items && items.length > 0) {
                        let found = false;
                        if (!index) {
                            //need to find item in list
                            index = 0;
                            let findId = entityProvider.getEntityId(state.current);
                            for (index = 0; index < items.length; index++) {
                                if (entityProvider.getEntityId(items[index]) == findId) {
                                    found = true;
                                    break;
                                }
                            }
                        } else {
                            found = true;
                        }

                        if (found) {
                            itemsNav.total = items.length;
                            if (index - 1 >= 0) {
                                itemsNav.previousId = entityProvider.getEntityId(items[index - 1]);
                                itemsNav.hasPrevious = true;
                            }
                            if (index + 1 < items.length) {
                                itemsNav.nextId = entityProvider.getEntityId(items[index + 1]);
                                itemsNav.hasNext = true;
                            }
                        }
                        itemsNav.current = index + 1;
                        itemsNav.hasCurrent = itemsNav.current > 0;
                    }
                }

                state.itemsNavigation = itemsNav;
            },
            setCurrentLoading (state, value) {
                state.currentLoading = value
            },
            setCurrentLoadingError (state, value) {
                state.currentLoadingError = value
            },
            setCurrentLoadingErrorValue (state, value) {
                state.currentLoadingErrorValue = value
            },
            setCurrentDirty (state, value) {
                state.currentDirty = value
            },

            setItems (state, { model }) {
                let list = model ?? { data:[], total: 0 };
                let index = 0;
                list.data.map(function(item) {
                    if(item) {
                        item.index = index++;
                    }
                    return entityProvider.augmentEntity(self, item)
                });

                state.items = list
            },
            setItemsLoading (state, value) {
                state.itemsLoading = value;
            },
            setItemsLoadingError(state, value) {
                state.itemsLoadingError = value;
            },
            setItemsLoadingErrorValue(state, value) {
                state.itemsLoadingErrorValue = value;
            },
            setItemsDirty (state, value) {
                state.itemsDirty = value;
            },

        };

        this.actions = {

            markDirty({ commit }) {
                commit('setCurrentDirty', true)
            },

            replace({ commit }, {id, model}) {
                commit('setCurrent', {id, model})
            },

            select ({ state, commit, rootState }, id) {

                if(state.currentId !== id || state.currentDirty) {

                    commit('setCurrent', {id});
                    commit('setCurrentLoadingError', false);
                    commit('setCurrentLoadingErrorValue', null);

                    if(id) {
                        let orgId = rootState.organization.currentId;

                        commit('setCurrentLoading', true);
                        return entityProvider.getById(orgId, id)
                            .then(value => self.wait(REQUEST_DELAY, value))
                            .then(model => {
                                let id = entityProvider.getEntityId(model);
                                commit('setCurrent', {id, model});
                                return model
                            }).catch(function (error) {
                                console.log(error);
                                commit('setCurrentLoadingError', true);
                                commit('setCurrentLoadingErrorValue', errors.parseError(error, entityProvider.getEntityType()));
                                return null
                            })
                            .then(value => {
                                commit('setCurrentLoading', false);
                                commit('setCurrentDirty', false);
                                return value
                            });
                    }
                }

                return new Promise(resolve => resolve(state.current));
            },

            save ({ commit, rootState }, entity ) {

                if(entity) {

                    let orgId = rootState.organization.currentId;

                    commit('setCurrentLoading', true);
                    return entityProvider.insertOrUpdate(orgId, entity)
                        .then(value => self.wait(REQUEST_DELAY, value))
                        .then(model => {
                            let id = entityProvider.getEntityId(model);
                            commit('setCurrent', { id, model });
                            //items list may not match the value of current anymore
                            commit('setItemsDirty', true );
                            return model != null
                        }).catch(function (error) {
                            // handle error
                            console.log(error);
                            return false
                        }).then(value => {
                            commit('setCurrentLoading', false);
                            return value
                        });
                }

                return new Promise(resolve => resolve(false));
            },

            delete ({ commit, rootState }, id) {

                if(id) {

                    let orgId = rootState.organization.currentId;

                    commit('setCurrentLoading', true);
                    return entityProvider.deleteById(orgId, id)
                        .then(value => self.wait(REQUEST_DELAY, value))
                        .then(model => {
                            commit('setCurrent', {});
                            commit('setItemsDirty', true);
                            return model != null
                        }).catch(function (error) {
                            // handle error
                            console.log(error);
                            return false
                        }).then(value => {
                            commit('setCurrentLoading', false);
                            commit('setCurrentDirty', false);
                            return value
                        });
                }

                return new Promise(resolve => resolve(false));
            },


            list ({ commit, rootState }, params) {

                const orgId = rootState.organization.currentId;
                const defaultParams = { athleteId: rootState.athlete.currentId, rangeLimit: 'all' }

                const { athleteId, rangeLimit } = params || defaultParams;

                commit('setItemsLoadingError', false);
                commit('setItemsLoadingErrorValue', null);
                commit('setItemsLoading', true);

                return entityProvider
                    .getItems(orgId, athleteId, rangeLimit)
                    .then(value => self.wait(REQUEST_DELAY, value))
                    .then(model => {
                        commit('setItems', {model});
                        commit('setItemsDirty', false);
                        commit('setCurrentDirty', true);
                        return model
                    }).catch(function (error) {
                        console.log(error);
                        commit('setItemsLoadingError', true);
                        commit('setItemsLoadingErrorValue', errors.parseError(error, entityProvider.getEntityType()));
                        return null;
                    }).then(value => {
                        commit('setItemsLoading', false);
                        return value;
                    });
            }
        };
    }

    normalizeEntityName( id, entity, fallback ) {
        let name = '-';
        if(id && id !== '') {
            name = '' +id;
        }
        if(entity) {
            name = entity.name;
            name = (name !== undefined && name !== '') ? name : fallback;
        }
        return name ?? '-';
    }

    wait(ms, value) {
        return new Promise(resolve => setTimeout(resolve, ms, value));
    }

    parseDate(value) {
        if(value && value !== '') {
            return moment(value).toDate();
        }

        return null;
    }



}